<template>
    <div class="collection-item-box" @click="$modal.open('user', user)">
        <h2 class="truncate" v-text="user.display_name"></h2>
        <p v-text="user.username"></p>
        <hr>
        <div class="flex justify-between">
            <vue-tag class="bg-blue-lightest text-blue-light" icon="membership-card-solid">{{ user.role.label }}</vue-tag>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>